import { Outlet } from "react-router-dom";
import Header from "../components/layout/header/header";
import Footer from "../components/layout/footer/footer";

declare global {
  interface Window {
    dataLayer: any;
  }
}

function Main() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

export default Main;
